import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

type HandlerType = Handler<
    {
        firstName?: string;
        lastName?: string;
        properties?: {
            phone?: string;
            language?: string;
        }
        phoneError?: string

    }
>;

export const xDispatchUpdateAccountSettings: HandlerType = props => {
    props.dispatch({
        ...props.parameter,
        type: "xAccountSettings/updateAccountSettings",
    } as any);
};

export const chain = [xDispatchUpdateAccountSettings];

const xUpdateAccountSettings = createHandlerChainRunner(chain, "xUpdateAccountSettings");
export default xUpdateAccountSettings;
